import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
import ScreenSizes from 'screen_sizes';
import Grid from 'realize_overrides/components/grid/grid';
import { forwardPropsToState } from 'utils/react_utils';
import { generateUUID } from 'utils/uuid';
import { GridFormActions } from '../../../grid_form/reflux/grid_form_store';

@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.RestActionsMixin)
@forwardPropsToState([
	{ prop: 'clientSideData' },
	{ prop: 'clientSidePageCount' },
	{ prop: 'initialValues' },
	{ prop: 'formAction' },
	{ prop: 'selectedRowId' },
	{ prop: 'selectedDataRow' },
])

export default class GridForm extends React.Component {
	static propTypes = {
		clientSide: PropTypes.bool,
		clientSideIdField: PropTypes.string,
		url: PropTypes.string,
		paginationConfigs: PropTypes.object,
		sortConfigs: PropTypes.object,
		sortData: PropTypes.object,
		filter: PropTypes.object,
		columns: PropTypes.object,
		data: PropTypes.object,
		dataRowsParam: PropTypes.string,
		countParam: PropTypes.string,
		actionButtons: PropTypes.object,
		form: PropTypes.object,
		createButton: PropTypes.object,
		createButtonMobile: PropTypes.object,
		updateButton: PropTypes.object,
		cancelButton: PropTypes.object,
		isLoading: PropTypes.bool,
		selectable: PropTypes.oneOf(['multiple', 'none', 'one']),
		eagerLoad: PropTypes.bool,
		readOnly: PropTypes.bool,
		gridComponent: PropTypes.func,
		formComponent: PropTypes.func,
		onSubmit: PropTypes.func,
		onReset: PropTypes.func,
		onSuccess: PropTypes.func,
		onError: PropTypes.func,
		onLoadSuccess: PropTypes.func,
		onLoadError: PropTypes.func,
		onDestroy: PropTypes.func,
		onDestroySuccess: PropTypes.func,
		onDestroyError: PropTypes.func
	};

	static defaultProps = {
		clientSide: false,
		clientSideIdField: '_clientSideId',
		form: {},
		actionButtons: { member: [], collection: [] },
		themeClassKey: 'gridForm',
		isLoading: false,
		createButton: {
			name: 'actions.add',
			icon: 'add'
		},
		createButtonMobile: {
			name: 'actions.mobileAdd',
			icon: 'add'
		},
		updateButton: {
			name: 'actions.update',
			icon: 'edit'
		},
		cancelButton: {
			name: 'actions.cancel',
			style: 'cancel'
		},
		selectable: 'multiple',
		eagerLoad: true,
		readOnly: false,
		gridComponent: Grid,
		formComponent: Form,
		data: {
			dataRows: []
		},
		onSubmit: function(event, postData) {},
		onReset: function(event) {},
		onSuccess: function(data, status, xhr) { return true; },
		onError: function(xhr, status, error) { return true; },
		onLoadSuccess: function(data) {},
		onLoadError: function(xhr, status, error) {},
		onDestroy: function(event, id) {},
		onDestroySuccess: function(data) {},
		onDestroyError: function(xhr, status, error) {}
	};

	state = {
		formAction: 'create',
		selectedDataRow: null,
		selectedRowId: null,
		isLoading: this.props.isLoading,
		clientSideData: (this.props.data.dataRows || []),
		clientSidePageCount: null
	};

	constructor(props) {
		super(props);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleResetButtonClick = this.handleResetButtonClick.bind(this);
		this.handleFormReset = this.handleFormReset.bind(this);
		this.handleFormSubmitSuccess = this.handleFormSubmitSuccess.bind(this);
		this.handleFormSubmitError = this.handleFormSubmitError.bind(this);

		setTimeout(() => { this.executeDestroyAction = this.executeDestroyAction.bind(this); }, 250);
		this.handleDestroySuccess = this.handleDestroySuccess.bind(this);
		this.handleDestroyError = this.handleDestroyError.bind(this);
	}

	/* Action buttons props parsers */

	getActionButtons() {
		let objectReturn = {};
		let defaultActionButtons = this.getDefaultActionButtons();

		Object
			.keys(defaultActionButtons)
			.forEach(key => {
				objectReturn[key] = this.mergeActionButtonsProps(defaultActionButtons[key], this.props.actionButtons[key]);
			});

		return objectReturn;
	}

	getDefaultActionButtons() {
		return {
			member: this.getDefaultMemberActionButtons(),
			collection: [],
		};
	}

	getDefaultMemberActionButtons() {
		if(this.props.readOnly) {
			return [];
		}

		return [
			this.getDefaultEditActionProps(),
			this.getDefaultDestroyActionProps()
		];
	}

	getDefaultEditActionProps() {
		return {
			id: 'edit',
			icon: 'edit',
		};
	}

	getDefaultDestroyActionProps() {
		return {
			id: 'destroy',
			icon: 'destroy',
			onClick: (event, id) => {
				event.persist();
				this.executeDestroyAction(event, id);
			},
		};
	}

	executeDestroyAction (event, id) {
		this.props.onDestroy(event, id);
		if(event.isDefaultPrevented()) return;

		(this.props.clientSide)
		? this.destroyActionClientSide(event, id)
		: this.destroyActionServerSide(event, id);
	}

	destroyActionClientSide(event, id) {
		const itemIndex = this.findClientSideDataIndex(id);

		this.state.clientSideData.splice(itemIndex, 1);
		this.forceUpdate(this.props.onDestroySuccess);
	}

	destroyActionServerSide(event, id) {
		const destroyUrl = this.getRestActionUrl('destroy', id);
		const destroyMethod = this.getRestActionMethod('destroy');

		if (!this.props.destroyConfirm || confirm(this.props.destroyConfirm)) {
			this.setState({ isLoading: true });
			this.resetForm();

			$.ajax({
				url: destroyUrl,
				method: destroyMethod,
				success: this.handleDestroySuccess,
				error: this.handleDestroyError
			});
		}
	}

	handleDestroySuccess(data, status, xhr) {
		this.props.onDestroySuccess(data, status, xhr);
		this.loadGridData();
	}

	handleDestroyError(xhr, status, error) {
		this.setState({ isLoading: false });
		this.props.onDestroyError(xhr, status, error);
	}

	mergeActionButtonsProps(defaultButtonsProps, buttonsProps) {
		return defaultButtonsProps.concat(buttonsProps)
			.reduce((acc, currentProps) => {
				const repeatedPropsIndex = acc.findIndex((ap) => ap.id.toUpperCase() === currentProps.id.toUpperCase());
				(repeatedPropsIndex >= 0)
				? acc[repeatedPropsIndex] = Object.assign({}, acc[repeatedPropsIndex], currentProps)
				: acc.push(currentProps);

				return acc;
			} ,[])
			.filter((buttonProps) => !buttonProps.hidden);
	}

	/* Event handlers */

	handleResetButtonClick(event) {
		const formRef = this.refs.form;

		if (!(typeof formRef.haveNativeReset == "function" && !!formRef.haveNativeReset()))
			this.handleFormReset(event);
	};

	handleFormReset (event) {
		this.props.onReset(event);
	}

	handleFormSubmit (event, postData) {
		this.props.onSubmit(event, postData);
		if(this.props.clientSide && !event.isDefaultPrevented()) {
			this.handleClientSideFormSubmit(event, postData);
		}
	}

	handleClientSideFormSubmit(event, postData) {
		event.preventDefault();
		const submittedDataRow = Object.assign({}, postData);
		const submittedDataRowIndex = this.findClientSideDataIndex(submittedDataRow[this.props.clientSideIdField]);

		if(submittedDataRowIndex >= 0) {
			this.state.clientSideData.splice(submittedDataRowIndex, 1, submittedDataRow);
		} else {
			submittedDataRow[this.props.clientSideIdField] = generateUUID();
			this.state.clientSideData.push(submittedDataRow);
		}

		if (this.state.formAction !== 'create')
			this.handleFormReset(event);

		this.props.onSuccess(event, postData);
	}

	handleFormSubmitError (xhr, status, error) {
		return this.props.onError(xhr, status, error);
	}

	handleFormSubmitSuccess (data, status, xhr) {
		if(this.props.onSuccess(data, status, xhr)) {
			this.loadGridData();
			this.resetForm();
		}
	}

	/* From Props parsing functions */

	getFormProps() {
		const mergeProps = $.extend(true, { style: 'filter' }, this.props.form, {
			id: this.props.id,
			action: this.getFormAction(),
			data: this.getFormData(),
			method: this.getFormMethod(),
			resource: this.getFormResource(),
			inputs: this.getFormInputs(),
			errors: this.props.errors,
			submitButton: this.getFormSubmitButton(),
			otherButtons: this.getFormOtherButtons(),
			formAction: this.state.formAction,
			isLoading: this.props.isLoading,
			isMobile: this.props.isMobile,
			onSubmit: this.handleFormSubmit,
			onReset: this.handleFormReset,
			onSuccess: this.handleFormSubmitSuccess,
			onError: this.handleFormSubmitError,
			ref: "form"
		});

		return mergeProps;
	}

	getFormAction() {
		if(this.props.clientSide) return null;
		return this.getRestActionUrl(this.state.formAction, this.state.selectedRowId);
	}

	getFormData() {
		return this.state.selectedDataRow;
	}

	getFormMethod() {
		return this.getRestActionMethod(this.state.formAction);
	}

	getFormResource() {
		return this.props.clientSide ? null : this.props.form.resource;
	}

	getFormInputs() {
		const formInputs = this.props.form.inputs;
		if(this.props.clientSide) {
			formInputs[this.props.clientSideIdField] = { component: 'hidden' };
		}

		return formInputs;
	}

	getFormSubmitButton() {
		let mobile = this.props.isMobile;

		if(mobile === false){
			return (this.state.formAction === 'update' && window.innerWidth > ScreenSizes.SMALL_SCREEN_WIDTH)
			? this.props.updateButton
			: this.props.createButton;
		} else {
			return (this.state.formAction === 'update' && window.innerWidth > ScreenSizes.SMALL_SCREEN_WIDTH)
			? this.props.updateButton
			: this.props.createButtonMobile;
		}
	}

	getFormOtherButtons() {
		if(this.state.formAction === 'update' && window.innerWidth > ScreenSizes.SMALL_SCREEN_WIDTH) {
			return [Object.assign({}, this.props.cancelButton, {
				type: "reset",
				onClick: this.handleResetButtonClick
			})];
		}

		return [];
	}

	/* Grid Props parsing functions */

	getGridProps () {
		const gridProps = Object.assign({}, this.propsWithoutCSS());
		gridProps.actionButtons = this.getActionButtons();
		gridProps.ref = "grid";
		gridProps.onPagination = () => { };// this.handleGridPagination.bind(this);

		if (this.props.clientSide) {
			Object.assign(gridProps, {
				url: '',
				selectable: 'none',
				eagerLoad: false,
				dataRowIdField: this.props.clientSideIdField,
				data: {
					dataRows: this.state.clientSideData,
					count: this.state.clientSidePageCount || this.state.clientSideData.length
				}
			});
		}

		return gridProps;
	}

	handleGridPagination({ page, perPage, dataRows }) {
		GridFormActions.loadNextPageData({ dataRows: dataRows, gridPage: page, gridPerPage: perPage }, this.props.name);
	}

	/* Helper functions */

	resetForm() {
		const { form } = this.refs;

		if (typeof form.reset === "function")
			form.reset();
	}

	serialize () {
		const gridRef = this.refs.grid;
		return gridRef.serialize();
	}

	loadGridData () {
		const gridRef = this.refs.grid;
		gridRef.loadData();
	}

	findClientSideDataIndex (id) {
		return this.state.clientSideData.map(data => data.id).indexOf(id);
	}

	/* Renderers */

	renderForm() {
		if(this.props.readOnly) return;
		return React.createElement(this.props.formComponent, this.getFormProps(), null);
	}

	renderGrid() {
		return React.createElement(this.props.gridComponent, this.getGridProps(), null);
	}

	render() {
		return (
			<div className={this.className()}>
				<div className={this.className() + "__form"}>
					{this.renderForm()}
				</div>

				<div className={this.className() + "__grid"}>
					{this.renderGrid()}
				</div>
			</div>
		);
	}
}
